import config from '../../config';

export default function uploadsMiddleware(store) {
  return (next) => (action) => {
    switch (action.type) {
      case 'account/fill':
        return next(action);
      case 'account/submit':
        store.dispatch({ type: 'account/status', payload: 'loading' });
        const { form } = store.getState().account;
        var validation = validateForm(form);
        if (validation != null) {
          store.dispatch({
            type: 'account/validation',
            payload: { status: 'done', validation },
          });
          return;
        } else {
          store.dispatch({
            type: 'account/validation',
            payload: { status: 'loading', validation: {} },
          });
        }
        submitForm(action.payload);
        break;
      case 'account/clearerror':
        store.dispatch({
          type: 'account/error',
          payload: { status: 'done', error: null },
        });
        break;
      case 'account/validatetimecode':
        if (validateTimeCode(action.payload)) {
          clearTimeCode(action.payload);
          store.dispatch({
            type: 'account/success',
            payload: { status: 'success' },
          });
        }
        break;
      default:
        return next(action);
    }
  };
}

function validateTimeCode(code) {
  try {
    if (!code) return false;
    if (!window || !window.sessionStorage) return false;
    if (typeof code !== 'string') return false;
    if (code.length < 1 || code.length > 20) return false;
    return (
      window.sessionStorage.getItem(`requestaccount_timecode_${code}`) === code
    );
  } catch (ex) {
    console.log(ex);
    return false;
  }
}

function recordTimeCode() {
  try {
    const code = new Date().getTime();
    window.sessionStorage.setItem(`requestaccount_timecode_${code}`, code);
    return code;
  } catch (ex) {
    console.log(ex);
  }
}

function clearTimeCode(code) {
  try {
    window.sessionStorage.removeItem(`requestaccount_timecode_${code}`);
  } catch (ex) {
    console.log(ex);
  }
}

function validateForm(form) {
  var result = {};
  !form.firstName && (result.first = 'Invalid first name');
  !form.lastName && (result.last = 'Invalid last name');
  !form.companyName && (result.company = 'Invalid company name');
  !/^[a-zA-Z_.0-9]+@[a-zA-Z_.0-9]+\.[a-zA-Z]+$/gi.test(form.email) &&
    (result.email = 'Invalid email');
  return Object.keys(result).length > 0 ? result : null;
}

function submitForm(form) {
  var code = recordTimeCode();
  form.elements['retURL'].value = `${config.requestAccountRetURL}/${code}`;
  form.submit();
}
